import React, { useEffect } from "react";

export default function ImsPolicy() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-secondary via-secondary to-gray-100 py-12 md:py-16 px-4 md:px-8 lg:px-12">
      <div className="max-w-6xl mx-auto">
        {/* Hero Section */}
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-block mb-6">
            {/* <div className="bg-primary/10 rounded-full p-4 md:p-6 inline-block">
              <svg
                className="w-12 h-12 md:w-16 md:h-16 text-primary"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
            </div> */}
          </div>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-6 bg-gradient-to-r from-primary to-primary/70 bg-clip-text text-transparent">
            IMS Policy
          </h1>
          <div className="max-w-3xl mx-auto">
            <p className="text-lg md:text-xl text-text-primary mb-4 leading-relaxed">
              K-Pack operates in accordance with the best practices of an Integrated
              Management System (IMS), ensuring consistent compliance, quality, and
              operational excellence across all functions.
            </p>
            <p className="text-base md:text-lg text-text-primary/80 font-medium">
              You can see IMS policy below.
            </p>
          </div>
        </div>

        {/* Policy Documents Grid */}
        <div className="space-y-8 md:space-y-10">
          <section className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100 transform hover:-translate-y-1">
            <div className="px-6 py-5 bg-gradient-to-r from-primary/5 to-primary/10 border-b border-gray-200">
              <div className="flex items-center gap-3">
                
                <h2 className="text-2xl font-bold text-primary">
                  IMS Policy - English
                </h2>
              </div>
            </div>
            <div className="p-6 md:p-8 flex justify-center bg-gradient-to-br from-gray-50 to-white">
              <img
                src="/ims_policy/IMS_English.webp"
                alt="IMS Policy English"
                className="max-h-[75vh] w-auto object-contain rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
              />
            </div>
          </section>

          <section className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100 transform hover:-translate-y-1">
            <div className="px-6 py-5 bg-gradient-to-r from-primary/5 to-primary/10 border-b border-gray-200">
              <div className="flex items-center gap-3">
                
                <h2 className="text-2xl font-bold text-primary">
                  IMS Policy - Urdu
                </h2>
              </div>
            </div>
            <div className="p-6 md:p-8 flex justify-center bg-gradient-to-br from-gray-50 to-white">
              <img
                src="/ims_policy/IMS_Urdu.webp"
                alt="IMS Policy Urdu"
                className="max-h-[75vh] w-auto object-contain rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
              />
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}


